import { useQuery, useLazyQuery, useSubscription } from "@apollo/react-hooks";
import {
  Button,
  Card,
  Col,
  Select,
  Form,
  Input,
  Layout,
  Row,
  Table,
  Tooltip,
  Menu,
  Radio,
} from "antd";
import React, { Fragment, useEffect, useState } from "react";
import EmployeeReportPDF from "../../PDF/EmployeeReportPDF/EmployeeReportPDF";
import { GET_USER_DETAILS } from "../../../Graphql/queries";
import {
  GET_EMPLOYEE_PERFORMANCE,
  GET_USER_LOCATION_LIST,
} from "../../../Graphql/subscriptions";
import { CustIcon } from "../../../Components/Svgs";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import moment from "moment";
import { components } from "react-select";
import "../PerformanceReport.less";

const { Content } = Layout;

export const EmployeePerformanceReportPage = () => {
  const [filter, setFilter] = useState("day");
  const [durationValue, setDurationValue] = useState("day");
  const [date, setDate] = useState(
    `${moment().format("Do")} ${moment().format("MMM, YYYY")}`
  );
  const [monthList, setMonthList] = useState(moment.months());
  const [userids, setUserIds] = useState([]);
  const [locationids, setLocationIds] = useState([]);
  const [options, setOptions] = useState([]);
  const [isMonth, setisMonth] = useState(false);
  const icon = () => {
    return <CustIcon type="filter" />;
  };
  const generatePDF = async (reportData) => {
    const doc = (
      <EmployeeReportPDF val={reportData?.getEmployeePerformanceReport} />
    );
    const asPdf = pdf([]);
    asPdf.updateContainer(doc);
    const blob = await asPdf.toBlob();
    saveAs(blob, "EmployeePerformance.pdf");
  };
  const columns = [
    {
      title: "Employee",
      key: "employee",
      onFilter: (value, record) => record.user_name.includes(value),
      sorter: (a, b) => a.user_name.localeCompare(b.user_name),
      ellipsis: true,
      render: (record) => {
        return <span>{record?.user_name}</span>;
      },
    },
    {
      title: <span>Assigned Task</span>,
      key: "Assigned Task",
      sorter: (a, b) => a.assigned - b.assigned,
      render: (record) => {
        return <span>{record?.assigned || 0}</span>;
      },
    },
    {
      title: "Completed",
      key: "completed",
      sorter: (a, b) => a.completed - b.completed,
      render: (record) => {
        return <span style={{ color: "green" }}>{record?.completed || 0}</span>;
      },
    },
    {
      title: "Not Completed",
      key: "incomplete",
      sorter: (a, b) => a.incomplete - b.incomplete,
      render: (record) => {
        return (
          <span style={{ color: "orange" }}>{record?.incomplete || 0}</span>
        );
      },
    },
    {
      title: "Escalated",
      key: "escalated",
      sorter: (a, b) => a.escalated - b.escalated,
      render: (record) => {
        return <span style={{ color: "red" }}>{record?.escalated || 0}</span>;
      },
    },
  ];
  const { data: userRoleData, loading: userRoleDataloading } = useQuery(
    GET_USER_DETAILS,
    {
      variables: { user_id: localStorage.getItem("user_id") },
    }
  );
  const { data, loading } = useSubscription(GET_EMPLOYEE_PERFORMANCE, {
    fetchPolicy: "cache-and-network",
    variables: {
      filter: filter,
      current_user: userids.length ? userids : null,
      user_id: localStorage.getItem("user_id"),
      locations: locationids.length ? locationids : null,
    },
  });

  const { data: userLocationList, loading: userLocationLoading } =
    useSubscription(GET_USER_LOCATION_LIST, {
      fetchPolicy: "cache-and-network",
      variables: {
        user_id: localStorage.getItem("user_id"),
      },
    });

  useEffect(() => {
    if (userRoleData) {
      if (!options.length && data) {
        const location = [];
        const obj = {};
        obj.label = "Filter by User";
        obj.options = [];
        data?.getEmployeePerformanceReport.map((itm) => {
          const val = {};
          val.label = itm.user_name;
          val.value = itm.user_id;
          val.type = "employee";
          obj.options.push(val);
          return options;
        });
        location.push(obj);
        const obj2 = {};
        obj2.label = "Filter by Locations";
        obj2.options = [];
        userLocationList?.getUsersById?.user_location_maps.map((itm) => {
          const val = {};
          val.label = itm.locationDetails.location_name;
          val.value = itm.locationDetails.location_id;
          val.type = "location";
          obj2.options.push(val);
          return options;
        });
        location.push(obj2);
        setOptions(location);
      }
    }
  }, [userRoleData, data, userLocationList]);

  const onFilterChange = (values, isMonth) => {
    const duration = values.toString();
    if (duration === "day") {
      setDate(`${moment().format("Do")} ${moment().format("MMM, YYYY")}`);
    } else if (duration === "week") {
      setDate(
        `${moment().subtract(7, "days").format("Do MMM, YYYY")} - ${moment()
          .subtract(1, "days")
          .format("Do MMM, YYYY")}`
      );
    } else {
      setDate(moment(duration, "M").format("MMMM, YYYY"));
    }
    setDurationValue(duration);
    setFilter(duration);
    setisMonth(isMonth);
  };

  const onUserSelected = (values) => {
    const userID = [];
    const locationID = [];
    values.map((itm) => {
      if (itm.type === "location") {
        return locationID.push(itm.value);
      } else {
        return userID.push(itm.value);
      }
    });
    setLocationIds(locationID);
    setUserIds(userID);
  };

  return (
    <Fragment>
      <Content className="site-body-layout">
        <div className="employeeListSec" style={{ width: "100%" }}>
          <div className="employeeSearch mt-3">
            <Form name="basic" onFinish={onFilterChange}>
              <Row gutter={15}>
                <Col xs={24} sm={12} md={12} lg={12} xl={24}>
                  <div className="secSubTitle pageSubTilte">
                    <div className="stLeft">
                      <h4 className="">{date}</h4>
                    </div>
                  </div>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12} xl={10} xxl={7}>
                  <Form.Item name="duration">
                    <Radio.Group
                      className="d-flex"
                      onChange={(e) => onFilterChange(e.target.value, false)}
                      defaultValue="day"
                      value={durationValue}
                      style={{ marginBottom: 8 }}
                    >
                      <Radio.Button
                        onClick={(e) => onFilterChange("day", false)}
                        className={isMonth ? "unCheck" : ""}
                        value={"day"}
                        style={{ minWidth: "50%" }}
                      >
                        Today
                      </Radio.Button>
                      <Radio.Button
                        onClick={(e) => onFilterChange("week", false)}
                        className={isMonth ? "unCheck" : ""}
                        value={"week"}
                        style={{ minWidth: "50%" }}
                      >
                        Last 7 Day
                      </Radio.Button>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={10}
                  md={10}
                  xl={5}
                  xxl={4}
                  className="text-md-left text-center ml-xl-auto"
                >
                  <Form.Item name="month">
                    <Select
                      style={{ width: "100%" }}
                      placeholder="Select Month"
                      onSelect={(e) => onFilterChange(e, true)}
                    >
                      {monthList.map((type, index) => (
                        <Select.Option key={index + 1} value={index + 1}>
                          {type}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col
                  xs={18}
                  sm={10}
                  md={10}
                  xl={5}
                  xxl={4}
                  className="text-md-left text-center"
                >
                  <Form.Item>
                    <Button
                      type="primary"
                      size="large"
                      shape="round"
                      className="w-100"
                      icon={<CustIcon type="doc-Download" className="mr-2" />}
                      onClick={() => generatePDF(data)}
                    >
                      Save as PDF
                    </Button>
                  </Form.Item>
                </Col>
                <Col className="text-center" xs={6} sm={4} lg={2} md={4}>
                  <Form.Item
                    name={`locations`}
                    rules={[
                      {
                        required: false,
                        message: "Please select atleast one location",
                        type: "array",
                      },
                    ]}
                  >
                    <ReactMultiSelectCheckboxes
                      hideSearch
                      onChange={onUserSelected}
                      options={options}
                      rightAligned
                      components={{
                        DropdownButtonIcon: icon,
                        GroupHeading: (props) => {
                          return <components.GroupHeading {...props} />;
                        },
                      }}
                      placeholderButtonLabel=""
                      getDropdownButtonLabel={({
                        placeholderButtonLabel,
                        value,
                      }) => {
                        return "";
                      }}
                      styles={{
                        dropdownButton: (base) => ({
                          ...base,
                          fontSize: "1em",
                          backgroundColor: "#f4fafd",
                          background: "#f4fafd",
                          fontWeight: 400,
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          color: "#000",
                          padding: 8,
                          fontWeight: "500",
                          fontSize: "0.9rem",
                        }),
                        menu: (provided, state) => ({
                          width: state.selectProps.width,
                          boxShadow: "0px 0px 0.71428571rem #21252942",
                          color: state.selectProps.menuColor,
                          padding: 8,
                          textAlign: "left",
                          borderRadius: "12px",
                        }),
                        groupHeading: (base) => ({
                          ...base,
                          flex: "1 1",
                          color: "#000",
                          margin: 0,
                          fontSize: "0.9rem",
                          textTransform: "none",
                          padding: "10px",
                        }),
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
          <div>
            <div>
              <Card className="announcementTableList">
                <Table
                  columns={columns}
                  dataSource={data?.getEmployeePerformanceReport}
                  loading={loading}
                />
              </Card>
            </div>
          </div>
        </div>
      </Content>
    </Fragment>
  );
};
